
import { Vue } from "vue-class-component";

export default class Star extends Vue {}
